(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * Cart (Shopify Ajax API)
   * ------------------------------------------------------------------- */
  var Cart = {
    get: function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    },
    add: function (id, quantity, sellingPlanId) {
      var item = { id: id, quantity: quantity || 1 };
      if (sellingPlanId) item.selling_plan = sellingPlanId;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    change: function (line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function (r) { return r.json(); });
    },
    updateCountBadges: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },
  };
  window.GelloCart = Cart;

  document.addEventListener('DOMContentLoaded', function () {
    /* -----------------------------------------------------------------
     * Mobile nav drawer
     * --------------------------------------------------------------- */
    var toggle = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    var setDrawer = function (open) {
      if (!toggle || !drawer) return;
      drawer.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var iconMenu = toggle.querySelector('[data-drawer-icon]');
      var iconClose = toggle.querySelector('[data-drawer-icon-close]');
      if (iconMenu) iconMenu.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    };
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        setDrawer(!drawer.classList.contains('is-open'));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setDrawer(false);
      });
      document.addEventListener('click', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (drawer.contains(e.target) || toggle.contains(e.target)) return;
        setDrawer(false);
      });
    }

    /* -----------------------------------------------------------------
     * Floating WhatsApp — raised above sticky add-to-cart on PDP
     * --------------------------------------------------------------- */
    var waFloat = document.querySelector('[data-wa-float]');
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    if (waFloat && stickyAtc) {
      var syncWaFloat = function () {
        waFloat.classList.toggle('is-raised', stickyAtc.classList.contains('is-shown'));
      };
      var mo = new MutationObserver(syncWaFloat);
      mo.observe(stickyAtc, { attributes: true, attributeFilter: ['class'] });
    }

    /* -----------------------------------------------------------------
     * Discount popup — after 6s, or on exit intent. Once per session.
     * --------------------------------------------------------------- */
    var overlay = document.querySelector('[data-popup-overlay]');
    if (overlay) {
      var shown = false;
      var markSeen = function () { sessionStorage.setItem('gello_popup_seen', '1'); };
      var open = function () {
        if (shown) return;
        shown = true;
        overlay.classList.add('is-open');
      };
      var close = function () {
        overlay.classList.remove('is-open');
        markSeen();
      };
      var timer = null;
      if (overlay.querySelector('[data-popup-success]')) {
        open();
      } else if (!sessionStorage.getItem('gello_popup_seen')) {
        timer = setTimeout(open, 6000);
        document.addEventListener('mouseout', function (e) {
          if (e.clientY <= 0 && !e.relatedTarget) open();
        });
      }
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      overlay.querySelectorAll('[data-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { if (timer) clearTimeout(timer); close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
      });
    }

    /* -----------------------------------------------------------------
     * Accordion (FAQ)
     * --------------------------------------------------------------- */
    document.querySelectorAll('[data-accordion]').forEach(function (acc) {
      acc.querySelectorAll('.gello-accordion-item').forEach(function (item) {
        var q = item.querySelector('.gello-accordion-q');
        if (!q) return;
        q.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          acc.querySelectorAll('.gello-accordion-item').forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.gello-accordion-q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('is-open');
            q.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });

    /* -----------------------------------------------------------------
     * Community / UGC horizontal carousel — arrows + autoplay
     * --------------------------------------------------------------- */
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var row = root.querySelector('[data-carousel-row]');
      if (!row) return;
      var step = row.clientWidth > 700 ? 340 : 250;
      var paused = false;
      root.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
        btn.addEventListener('click', function () { row.scrollBy({ left: -step, behavior: 'smooth' }); });
      });
      root.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () { row.scrollBy({ left: step, behavior: 'smooth' }); });
      });
      row.addEventListener('pointerenter', function () { paused = true; });
      row.addEventListener('pointerleave', function () { paused = false; });
      if (root.hasAttribute('data-carousel-auto')) {
        setInterval(function () {
          if (paused) return;
          var max = row.scrollWidth - row.clientWidth - 4;
          if (Math.abs(row.scrollLeft) >= max) row.scrollTo({ left: 0, behavior: 'smooth' });
          else row.scrollBy({ left: -step, behavior: 'smooth' });
        }, 3600);
      }
    });

    /* -----------------------------------------------------------------
     * Before / after slider
     * --------------------------------------------------------------- */
    document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
      var clip = slider.querySelector('[data-ba-clip]');
      var line = slider.querySelector('[data-ba-line]');
      var handle = slider.querySelector('[data-ba-handle]');
      var dragging = false;
      var apply = function (clientX) {
        var r = slider.getBoundingClientRect();
        var p = Math.max(4, Math.min(96, ((clientX - r.left) / r.width) * 100));
        clip.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        line.style.left = p + '%';
        handle.style.left = p + '%';
      };
      var down = function (e) {
        dragging = true;
        apply(e.clientX != null ? e.clientX : (e.touches && e.touches[0].clientX));
      };
      var move = function (e) {
        if (!dragging) return;
        apply(e.clientX != null ? e.clientX : (e.touches && e.touches[0] && e.touches[0].clientX));
      };
      var up = function () { dragging = false; };
      slider.addEventListener('pointerdown', down);
      handle.addEventListener('pointerdown', down);
      slider.addEventListener('touchstart', down, { passive: true });
      window.addEventListener('pointermove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('pointerup', up);
      window.addEventListener('touchend', up);
    });

    /* -----------------------------------------------------------------
     * PDP — tier/variant picker
     * --------------------------------------------------------------- */
    document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
      var tiers = Array.prototype.slice.call(pdp.querySelectorAll('[data-tier]'));
      var priceEl = pdp.querySelector('[data-pdp-price]');
      var savedEl = pdp.querySelector('[data-pdp-saved]');
      var permonthEl = pdp.querySelector('[data-pdp-permonth]');
      var addBtn = pdp.querySelector('[data-add-to-cart]');
      var stickyName = document.querySelector('[data-sticky-name]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyBtn = document.querySelector('[data-sticky-add]');
      var currentVariantId = null;

      /* The subscription tier carries a selling plan; the one-time tiers don't,
         so the attribute is removed rather than left over from a prior pick. */
      var applyPlan = function (btn, planId) {
        if (!btn) return;
        if (planId) btn.setAttribute('data-selling-plan-id', planId);
        else btn.removeAttribute('data-selling-plan-id');
      };

      var select = function (tier) {
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        currentVariantId = tier.getAttribute('data-variant-id');
        var planId = tier.getAttribute('data-selling-plan-id');
        if (priceEl) priceEl.textContent = tier.getAttribute('data-price-fmt');
        var origFmt = tier.getAttribute('data-orig-fmt');
        var saved = tier.getAttribute('data-saved-fmt');
        if (savedEl) { savedEl.textContent = saved || ''; savedEl.hidden = !saved; }
        var perMonth = tier.getAttribute('data-permonth-fmt');
        if (permonthEl) { permonthEl.textContent = perMonth || ''; permonthEl.hidden = !perMonth; }
        if (addBtn) addBtn.setAttribute('data-variant-id', currentVariantId);
        if (stickyBtn) stickyBtn.setAttribute('data-variant-id', currentVariantId);
        applyPlan(addBtn, planId);
        applyPlan(stickyBtn, planId);
        if (stickyName) stickyName.textContent = tier.getAttribute('data-name');
        if (stickyPrice) stickyPrice.textContent = tier.getAttribute('data-price-fmt') + (perMonth ? ' · ' + perMonth : '');
      };

      tiers.forEach(function (t) {
        t.addEventListener('click', function () { select(t); });
        if (t.classList.contains('is-selected')) select(t);
      });

      /* Sticky add-to-cart bar shows once user scrolls past the buy box */
      var stickyAtcEl = document.querySelector('[data-sticky-atc]');
      if (stickyAtcEl) {
        window.addEventListener('scroll', function () {
          stickyAtcEl.classList.toggle('is-shown', window.scrollY > 480);
        }, { passive: true });
      }

      var addToCart = function (btn) {
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        var planId = btn.getAttribute('data-selling-plan-id');
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'מוסיפה…';
        Cart.add(id, 1, planId).then(function () {
          return Cart.get();
        }).then(function (cart) {
          Cart.updateCountBadges(cart.item_count);
          window.location.href = '/cart';
        }).catch(function () {
          btn.textContent = 'שגיאה — נסי שוב';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
        });
      };
      if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });
      if (stickyBtn) stickyBtn.addEventListener('click', function () { addToCart(stickyBtn); });
    });

    /* -----------------------------------------------------------------
     * Cart page — quantity / remove via AJAX
     * --------------------------------------------------------------- */
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        Cart.change(line, 0).then(function () { window.location.reload(); });
      });
    });
  });
})();
